import React, { useState, useEffect } from "react";
import leftPng from "../../../../content/images/left.png";
import $ from "jquery";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as GC from "../../../common/common";

const Edit = () => {
  const [selecStatus, handleSelectstatus] = useState(false);

  useEffect(() => {
    $(document).on("click", ".popuptext-dropdown-a", function () {
      $("#" + $(this).attr("name") + "-select").val($(this).text());
      $("#" + $(this).attr("name") + "-select");
      var test = $("#" + $(this).attr("name"));
      test[0].childNodes.forEach((element) => {
        element.className = "popuptext-dropdown-a";
      });
      $(this).attr("class", "popuptext-dropdown-a-selected");

      if ($(this).attr("name") === "e-algemeen-status") {
        handleSelectstatus(!selecStatus);
      }
    });

    /*** başlangıç tarihi değiştiğinde, bitiş tarihinin başlangıç tarihinden küçük olmamasını control eder */
    $("#e-startDate").change(function () {
      if (this.value > $("#e-endDate").val()) {
        $("#e-endDate").val(this.value);
      }
      $("#e-endDate").attr("min", this.value);
    });
  });

  const handleEdit = async () => {
    $("#cover-spin").show(0);
    var actief;
    if ($("#e-workorder-active").is(":checked")) {
      actief = true;
    } else actief = false;
    var complete;
    if ($("#e-workorder-active").is(":checked")) {
      complete = true;
    } else complete = false;
    var naam = $("#e-workorder-naam").val();
    var code = $("#e-workorder-code").val();
    var omschrijving = $("#e-workorder-omschrijving").val();

    var id = $("#e-identification").val();
    var model = {
      content: {
        algemeen: {
          code: code,
          naam: naam,
          actief: actief,
          omschrijving: omschrijving,
        },
      },
      identification: id,
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_WORK_ORDERS],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then(async (result) => {
        if (
          result.data &&
          result.data.length > 0 &&
          result.data[0].identification !== id
        ) {
          isUnique = await false;
          $("#cover-spin").hide(0);

          alert("code is not unique");
        }
      });

    if (isUnique) {
      let result = await omnimap.SaveOrEditAction(
        model,
        "PATCH",
        id,
        window.$catalog_management_units_token
      );
      if (result.result.status === "OK") {
        CallBackFunctions.BeheereenheidEdit();
      }
    }
  };

  return (
    <div id="editSide" className="d-none">
      <div className="detail-title">Werkorder in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Werkorder
          </a>
        </div>
        <div className="float-right mt-0">
          <a className="button ok" onClick={handleEdit}>
            Opslaan
          </a>
        </div>
        <div className="float-right mt-0 w-20">
          <a id="return-detail" className="button back">
            Annuleren
          </a>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam</div>
            <div className="box-title-2-active">
              <input id="e-workorder-naam" autocomplete="off" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2">
              <input id="e-workorder-code" autocomplete="off" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2">
              <input id="e-workorder-omschrijving" autocomplete="off" />
            </div>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        {/* <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Status</div>
            <div
              className={
                selecStatus
                  ? "box-title-2 select-content open"
                  : "box-title-2 select-content"
              }
              onClick={() => handleSelectstatus(!selecStatus)}
            >
              <input
                id="e-algemeen-status-select"
                type="button"
                className="edit-dropdown"
              />
              <div class="popup-dropdown">
                <span
                  className={
                    selecStatus
                      ? "popuptext-dropdown show"
                      : "popuptext-dropdown"
                  }
                  id="e-algemeen-status"
                ></span>
              </div>
            </div>
          </div>
        </div> */}
        {/* 
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Compleet</div>
            <label className="switch">
              <input id="e-algemeen-compleet" type="checkbox" />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div> */}
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="e-workorder-active" type="checkbox" />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
      </div>

      <input hidden="true" id="e-identification" />
    </div>
  );
};

export default Edit;
